import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface Message {
	type: string;
	payload: any;
}

type MessageCallback = (payload: any) => void;

@Injectable({ providedIn: 'root' })
export class EventService implements OnDestroy {
	private handler = new Subject<Message>();
	private channel: BroadcastChannel;

	constructor() {
		this.channel = new BroadcastChannel('dashboard-events');

		// Listen for messages from other tabs
		this.channel.onmessage = (event) => {
			const { type, payload } = event.data;

			// Avoid re-broadcasting to prevent infinite loops
			this.broadcast(type, payload, false);
		};
	}

	broadcast(type: string, payload: any, toChannel: boolean = true) {

		// Send to other tabs if needed
		if (toChannel) {
			this.channel.postMessage({ type, payload });
		}

		// Notify within this tab
		this.handler.next({ type, payload });
	}

	subscribe(type: string, callback: MessageCallback): Subscription {
		return this.handler.pipe(
			filter((message: Message) => message.type === type),
			map((message: Message) => message.payload)
		).subscribe(callback);
	}

	ngOnDestroy() {
		this.channel.close();
	}
}
